import { css } from '@/styled-system/css';

export const paginationRootStyles = css.raw({
  'display': 'block',
  'marginInline': 'auto',
  'width': '100%',
  'userSelect': 'none',
  '& > [data-c11n-component="Divider"]:is(:first-child)': {
    marginBlockEnd: 'default',
  },
});
